// start:ng42.barrel
export * from './cancel-dates.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/cancel-dates/index.ts